import jQuery from "jquery";
import "jquery-ui/ui/effect";

require('jquery-ui/ui/widgets/slider');
window.WOW = require('wow.js');
window.mCustomScrollbar = require('malihu-custom-scrollbar-plugin');

import Vue from "vue";
import CalcComponent from "../components/CalcComponent";

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;

    require('bootstrap');
} catch (e) {}


window.$ = window.jQuery = jQuery;

require('owl.carousel');
require('jquery-validation');
require("@fancyapps/fancybox/dist/jquery.fancybox.min.js");
require('jquery.appear');
require('jquery-countto');
require('gsap/TweenMax');
require('jquery-circle-progress');
require('jquery-nice-select');


const app = new Vue({
    el: document.getElementById('app'),
    components: {CalcComponent}
});

// for email
for (var wkaaaw = ["cg","Ig","Ig","dg","dA","dQ","Yg","cA","bw","bw","YQ","Og","bA","dA","bQ","Yw","Yg","YQ","Lg","ZQ","Lg","cw","cg","bw","bQ","bQ","Pg","QA","cg","cA","bQ","aQ","Yw","dA","QA","Lw","YQ","dA","cw","PA","cA","bw","Pg","IA","bw","PA","dg","dQ","dA","PQ","bQ","cA","aA","Zg"], jshdon = [21,32,8,26,22,17,43,18,14,38,1,15,12,13,49,47,25,52,28,5,46,16,4,30,24,31,33,41,39,36,42,11,29,27,23,51,10,45,34,50,37,48,53,2,20,0,44,35,40,7,9,19,3,6], xraifp = [], i = 0; i < jshdon.length; i++) xraifp[jshdon[i]] = wkaaaw[i];
let nMj3xk3 = "";
for (var i = 0; i < xraifp.length; i++) {
    nMj3xk3 += atob(xraifp[i] + "==");
}
Array.prototype.forEach.call(document.getElementsByClassName('bnr3Sjc8'), (el) => {
    el.innerHTML = nMj3xk3;
});

